import { useMemo } from 'react';
import { Provider } from 'react-redux';

import { createReduxStore } from './config';
import { StoreProviderProps } from './StoreProvider.types';
import { getInitialState } from './StoreProvider.constants';

export const StoreProvider = (props: StoreProviderProps) => {
    const { children, locationPath, searchParams, store: externalStore } = props;

    const store = useMemo(
        () => externalStore ?? createReduxStore(getInitialState(locationPath, searchParams)),
        [externalStore, locationPath, searchParams],
    );

    return <Provider store={store}>{children}</Provider>;
};
